<div>Si è verificato un errore imprevisto.</div>
<div [routerLink]="['/']">Torna alla home</div>
